<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { 
        fetchOperadores, 
        saveOperador, 
        removeOperador, 
        searchOperadores, 
        subscribeToOperadores, 
        unsubscribeFromOperadores 
    } from '../controllers/operadorController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de operadores
    let operadorColumns = [
        { label: $t('fields.name'), field: 'nombre', type: 'text' },
        { label: 'Sucursal', field: 'sucursal', type: 'relation', relationField: 'descrip' }
    ];

    // Estructura del nuevo objeto Operador
    let newOperador = {
        nombre: '',
        sucursal: null, // Relación con la sucursal
        sta: true,
    };

    // Configuración de los campos para la edición de operadores
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },

        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
    ];

    // Función para cargar y transformar sucursales
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.operadores')}
    entityName="operador"
    newEntity={newOperador}
    columns={operadorColumns}
    fetchEntities={fetchOperadores}
    saveEntity={saveOperador}
    removeEntity={removeOperador}
    searchEntities={searchOperadores}
    subscribeToChanges={subscribeToOperadores}
    unsubscribeFromChanges={unsubscribeFromOperadores}
    editColumns={editColumns}
/>
